import { gql } from "graphql-tag";

export const ADMIN_USERS_QUERY = gql`
  query AdminUsers {
    adminUsers {
      id
      first_name
      last_name
      email
      role
      is_active
      created_at
      updated_at
      pharmacy {
        id
        name
        city
        state
      }
    }
    roles
  }
`;

export const PHARMACY_USERS_QUERY = gql`
  query PharmacyUsers($pharmacyId: ID) {
    pharmacyUsers(pharmacyId: $pharmacyId) {
      id
      first_name
      last_name
      email
      role
      is_active
      created_at
      updated_at
      pharmacy {
        id
        name
      }
    }
    roles
  }
`;

// Get a specific user by ID
export const USER_QUERY = gql`
  query User($id: ID!) {
    user(id: $id) {
      id
      first_name
      last_name
      email
      role
      phone_number
      is_active
      pharmacy {
        id
        name
      }
    }
    roles
  }
`;

// Create a new user
export const CREATE_USER_MUTATION = gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      id
      success
      code
      reason
    }
  }
`;

// Update an existing user
export const UPDATE_USER_MUTATION = gql`
  mutation UpdateUser($id: ID!, $input: UpdateUserInput!) {
    updateUser(id: $id, input: $input) {
      id
      success
      code
      reason
    }
  }
`;

// Delete a user
export const DELETE_USER_MUTATION = gql`
  mutation DeleteUser($id: ID!) {
    deleteUser(id: $id) {
      id
      success
      code
      reason
    }
  }
`;

// Assign pharmacy to user
export const ASSIGN_PHARMACY_MUTATION = gql`
  mutation AssignPharmacy($input: AssignPharmacyInput!) {
    assignPharmacy(input: $input) {
      success
      message
      code
      reason
      data
    }
  }
`;